import cn from "classnames";
import { useEffect, useState } from "react";

import DropzoneBlock from "@components/cmsBlocks/ContentBlock/components/DropzoneBlock/DropzoneBlock";
import ImageFile from "@components/cmsBlocks/ContentBlock/components/ImageFile/ImageFile";
import ThreeDFile from "@components/cmsBlocks/ContentBlock/components/ThreeDFile/ThreeDFile";
import VideoFile from "@components/cmsBlocks/ContentBlock/components/VideoFile/VideoFile";
import { FILE_TYPES } from "@config/config";
import { getFileType } from "@utils/utils";

import s from "../../ContentBlock.module.scss";

const getComponent = (file) => {
  if (!file?.src) return null;

  const fileType = getFileType(file.src);

  switch (fileType) {
    case FILE_TYPES.image:
      return ImageFile;
    case FILE_TYPES.threeD:
      return ThreeDFile;
    case FILE_TYPES.video:
      return VideoFile;
    default:
      return null;
  }
};

const GraphicFile = ({
  fileType,
  enabledComponent,
  isEditMode,
  file,
  updateField,
  isRenderComponent,
  isWidget,
  isWidgetEditing,
}) => {
  const [isVertical, setIsVertical] = useState(false);

  const Component = getComponent(file);

  useEffect(() => {
    if (file.src && fileType === FILE_TYPES.image) {
      const img = new window.Image();
      img.src = file.src;

      img.onload = () => {
        const isVertical = img.width / img.height < 4 / 3;
        setIsVertical(isVertical);
      };
    }
  }, [file.src]);

  if (enabledComponent && isEditMode) {
    return (
      <DropzoneBlock
        file={file}
        updateField={updateField}
        isWidget={isWidget}
        isWidgetEditing={isWidgetEditing}
        isVertical={isVertical}
      />
    );
  }

  if (!Component) return null;

  return (
    isRenderComponent && (
      <div className={cn(s.graphicFile, isVertical && s.isVertical)}>
        <Component
          isVertical={isVertical}
          setIsVertical={setIsVertical}
          file={file}
          isEditMode={isEditMode}
          updateField={updateField}
          enabledComponent={enabledComponent}
        />
      </div>
    )
  );
};

export default GraphicFile;
